import { CUSTOM_ELEMENTS_SCHEMA, Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperOptions } from 'swiper/types';
import { Video } from '@usheru-hff/shared/domain';
import { SwiperDirective } from '@usheru-hff/shared/ui-swiper';
import { UiVideoCardComponent } from '@usheru-hff/movie-detail/ui-video-card';

import { ENVIRONMENT, Environment } from '@environment';
import { SharedUiArrowModule } from '@usheru-hff/shared/ui-arrow';
import { FeatureCarouselComponent } from '@usheru-hff/community-elements/utils';

@Component({
  selector: 'ush-feature-videos-carousel',
  imports: [CommonModule, SwiperDirective, UiVideoCardComponent, SharedUiArrowModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './feature-videos-carousel.component.html',
  styleUrl: './feature-videos-carousel.component.scss'
})
export class FeatureVideosCarouselComponent extends FeatureCarouselComponent<Video> {
  private envLocal: Environment = inject(ENVIRONMENT);

  private readonly arrowTemplateDefault = 5;

  @Input() set videos(videos: Video[]) {
    this.items = videos;
  }

  protected override getSwiperConfig(): SwiperOptions {
    return {
      slidesPerView: 1.4,
      spaceBetween: 10,
      scrollbar: true,
      breakpoints: {
        480: {
          slidesPerView: 2.4,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 30
        }
      },
      navigation: this.getNavigationSelectors()
    };
  }

  override setUpArrowTemplate() {
    this.arrowTemplate =
      this.envLocal.carouselTypeParams?.videos?.arrowLayoutDesing?.top ||
      this.envLocal.carouselTypeParams?.videos?.arrowLayoutDesing?.down ||
      this.envLocal.carouselTypeParams?.videos?.arrowLayoutDesing?.side ||
      this.envLocal.carouselTypeParams?.videos?.arrowLayoutDesing?.inside ||
      this.arrowTemplateDefault;
  }

  get videoItems(): Video[] | undefined {
    return this.items;
  }
}
